import { Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, TextField } from '@mui/material';
import { CancelIcon, CopyLinkIcon, ReInviteIcon, TrashIcon } from '../../icon';
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors";
import { FaceAuthenticationModel, FaceRegistrationInviteLinkStatus, SecureFileRegistrationStatusModel } from '../../models/secure-file';
import GridComponent from '../shared/grid';
import _ from 'lodash';
import { UtilityService } from '../../services/UtilityService';
import { dateComparator } from '../shared/grid/grid.services';
import { ColDef, ValueGetterParams, ICellRendererParams, GridApi, CellClickedEvent } from 'ag-grid-community';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { ActionLabels, DialogHeaders, GridStatusLabelVariant, ToasterTexts, appNote, buttonLabels, emptyLabels } from '../shared/constants';
import { ActionsRenderer } from '../shared/grid/actionsRenderer';
import { SecureFileService } from '../../services/SecureFileService';
import { useEffect, useState } from 'react';
import { UserService } from '../../services/UserService';
import { ToasterType } from '../shared/toaster/toaster.model';
import setToast from '../../helpers/toaster.helper';
import { MessageService } from '../../services/MessageService';
import { v4 as uuid } from "uuid";
import { PlanMetrics } from '../../models/plan-metrics.model';
import Confirm_Dialog from '../shared/confirm-dialog.component';
import ButtonComponent from '../shared/button/button.component';
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';

interface Props {
    OnClose: (isConfim: boolean, fileName?: string) => void;
    Show: boolean;
    onGridReady: (params: any) => void;
    OnSelectionChanged: (data: any) => void
}

const SecureFileFaceAuthentication = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const FaceAuthenticationFiles: FaceAuthenticationModel[] = useSelector(selector.faceAuthenticatonFiles);
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)
    const IsNewOrgFlow: boolean = useSelector(selector.isNewOrgFlow);


    const [show, setShow] = useState<boolean>(false)
    const [contactNumber, setContactNumber] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [gridApi, setGridApi] = useState<GridApi>();
    const [columnApi, setcolumnApi] = useState<any>(null)
    const [rowData, SetRowData] = useState<FaceAuthenticationModel[]>(FaceAuthenticationFiles)
    const [openEditContactName, setEditConatctName] = useState<boolean>(false)
    const [selectedcontact, setSelectedContact] = useState<FaceAuthenticationModel>()

    const FaceAuthenticationColumnDefs: ColDef[] = [
        {
            field: "Contact Name",
            headerName: "Contact Name",
            valueGetter: (params: ValueGetterParams) => {
                return params.data.Name
            },
            onCellClicked: (event: CellClickedEvent) => { setEditConatctName(true); setSelectedContact(event.data) },
            headerCheckboxSelection: IsMobileDevice ? false : true,
            checkboxSelection: IsMobileDevice ? false : true,
            hide: IsMobileDevice,
            cellClass: "c-pointer",
            cellStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '100%',
                display: 'block'
            },
        },
        {
            field: "Phone Number",
            headerName: "Phone Number",
            hide: IsMobileDevice,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.ContactPhoneNumber
            },
        },
        {
            field: "InviteSenderName",
            headerName: "Sender Name",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.trimMessage(params.data?.InviteSenderName, 20)
            },
            hide: IsMobileDevice,
        },
        {
            field: "Status",
            headerName: "Status",
            valueGetter: (params: ValueGetterParams) => {
                if (params.data.Status === 1) {
                    return SecureFileRegistrationStatusModel.Registered;
                } else if (params.data.Status === 2) {
                    return SecureFileRegistrationStatusModel.Expired;
                } else {
                    return SecureFileRegistrationStatusModel.Pending;
                }
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data) {
                    const label =
                        params.data.Status === 1
                            ? SecureFileRegistrationStatusModel.Registered
                            : params.data.Status === 2
                                ? SecureFileRegistrationStatusModel.Expired
                                : SecureFileRegistrationStatusModel.Pending;

                    let variant;

                    if (params.data.Status === 1) {
                        variant = GridStatusLabelVariant.Active;
                    } else if (params.data.Status === 2) {
                        variant = GridStatusLabelVariant.Danger;
                    } else {
                        variant = GridStatusLabelVariant.Warning;
                    }

                    return {
                        component: StatusRenderer,
                        params: {
                            Variant: variant,
                            Label: label,
                            Id: params.data.ID
                        }
                    };
                }
                return undefined;
            }
        },
        {
            field: "UpdatedDate",
            headerName: "Updated Date",
            hide: IsMobileDevice,
            sort: "desc",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertDateToDay(params.data?.UpdatedAt)
            },
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data?.UpdatedAt, nodeB.data?.UpdatedAt),
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={getMenuActions(params.data)}
                {...params}
            />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice
        },
    ]

    const getMenuActions = (data: FaceAuthenticationModel) => {
        return [{
            Name: "Resend Invite",
            Icon: ReInviteIcon,
            Hide: (data.Status !== FaceRegistrationInviteLinkStatus.Pending || UtilityService.getPreferredTimeZoneTimeNow() >= new Date(data?.ExpiresAt)),
            OnClick: () => { reSendInvite(data.InviteLink, data.ContactPhoneNumber) },
        },
        {
            Name: "Regenerate Invite",
            Icon: ReInviteIcon,
            Hide: data.Status !== FaceRegistrationInviteLinkStatus.Expired,
            OnClick: () => { reGenerat(data.ContactPhoneNumber) }
        },
        {
            Name: "Copy Link",
            Icon: CopyLinkIcon,
            Hide: data.Status !== FaceRegistrationInviteLinkStatus.Pending,
            OnClick: () => { copyLink(data?.InviteLink) }
        },
        {
            Name: ActionLabels.DELETE,
            Icon: TrashIcon,
            Hide: false,
            OnClick: () => { openConfirmDialog(data) }
        }]
    }

    useEffect(() => {
        SetRowData(FaceAuthenticationFiles)
    }, [FaceAuthenticationFiles])


    const copyLink = (link) => {
        if (IsTeamsApp) {
            UtilityService.copyTextFromTeams(link)
            setToast(ToasterTexts.LINK_HAS_BEEN_COPIED, ToasterType.SUCCESS)
        }
        else {
            navigator.clipboard.writeText(link);
            setToast(ToasterTexts.LINK_HAS_BEEN_COPIED, ToasterType.SUCCESS)
        }
    }

    const openConfirmDialog = (data: FaceAuthenticationModel) => {
        setShow(true)
        setContactNumber(data.ContactPhoneNumber)
    }

    const closeConfirmDialog = (isConfim) => {
        let data = { phone_numbers: [contactNumber] }
        if (isConfim) {
            setIsLoading(true)
            SecureFileService.deleteInviteLinks(UserService.getCurrentUserFromLocalStorage()?.OrgId, data).then((res) => {
                setIsLoading(false)
                setShow(false)
                setToast(ToasterTexts.DELETE_INVITE, ToasterType.SUCCESS)
            }).catch((err) => {
                setIsLoading(false)
                setShow(false)
            })
        }
        else {
            setShow(false)
        }
    }

    const reSendInvite = (inviteLink: string, contactNumber: string) => {
        setContactNumber(contactNumber)
        sendMessage(inviteLink, contactNumber)
    }

    const reGenerat = (contactNumber) => {
        setContactNumber(contactNumber)
        sendFaceAuthenticationInvite(contactNumber)
    }

    const sendFaceAuthenticationInvite = async (contactNumber) => {
        const data = { "organization_id": UserService.getCurrentUserOrgId(), "falkon_user": UserService.getUserPhoneNumber()?.replace("+", ""), "falkon_user_name": UserService?.getCurrentUserFromLocalStorage()?.FullName }

        if (!IsNewOrgFlow && PlanMetrics.NormalTextingUsage.PlanCredits >= 0 && PlanMetrics.NormalTextingUsage.GetRemainingCredits() < 1) {
            setToast(ToasterTexts.CREDITS_PER_MONTH_ERROR_MESSAGE.replace('<CREDITS>', PlanMetrics.NormalTextingUsage.TotalCredits.toString()), ToasterType.DANGER);
            return;
        }
        setToast("Generating link...", ToasterType.INFO)
        MessageService.sendInvite(data, contactNumber?.replace("+", ""))
            .then(res => {
                if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                    const link = res.data.link;
                    sendMessage(link, contactNumber)
                }
                else {
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                }
            })
            .catch(error => {
                setToast(error?.data?.error, ToasterType.DANGER)

            })
    }

    const sendMessage = (body, contactNumber) => {
        if (!IsNewOrgFlow && PlanMetrics.NormalTextingUsage.PlanCredits >= 0 && PlanMetrics.NormalTextingUsage.GetRemainingCredits() < 1) {
            setToast(ToasterTexts.CREDITS_PER_MONTH_ERROR_MESSAGE.replace('<CREDITS>', PlanMetrics.NormalTextingUsage.TotalCredits.toString()), ToasterType.DANGER);
            return;
        }
        var formData = new FormData();

        let id = uuid();
        formData.append("Id", id)
        formData.append("Body", `Face Registration Link: ${body}`);
        formData.append("ToPhoneNumber", contactNumber);
        formData.append("File", undefined);
        formData.append("Credits", "1")

        MessageService.sendNewMessage(formData)
            .then((res) => {
                setToast(ToasterTexts.SEND_INVITE, ToasterType.SUCCESS)
            })
            .catch((error) => {
                if (
                    !!error &&
                    !!error.response &&
                    !!error.response.data &&
                    !!error.response.data.message
                )
                    setToast(error.response.data.message, ToasterType.DANGER, "default")

            });
        // HandlePushConversation(dispatch,
        //     [{
        //         ID: id,
        //         Message: body,
        //         PhoneNumber: number,
        //         IsOutbound: true,
        //         GroupChat: null,
        //         DeliveryStatus: DeliveryStatus.SENDING,
        //         MessageDateTime: new Date().toISOString(),
        //     } as ConversationModel],
        // )
    }

    const onSelectionChanged = () => {
        let SelectedContacts: FaceAuthenticationModel[] = gridApi.getSelectedRows()
        if (gridApi) {
            props.OnSelectionChanged(SelectedContacts)
        }
    }

    const onGridReady = (params) => {
        setGridApi(params.api)
        setcolumnApi(params.columnApi)
        props.onGridReady(params);
    }

    const editConatctName = () => {
        let data = { id: selectedcontact?.Id, Name: selectedcontact?.Name }
        setIsLoading(true)
        SecureFileService.editInviteConatctName(data).then((res) => {
            setIsLoading(false)
            setEditConatctName(false)
            setSelectedContact(undefined)
            setToast(ToasterTexts.CONTACT_EDIT_SUCCESS.replace('<Name>', (selectedcontact?.Name)), ToasterType.SUCCESS)
        }).catch((err) => {
            setIsLoading(false)
            setSelectedContact(undefined)
            setEditConatctName(false)
            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)

        })
    }

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            <GridComponent
                ColumnDefs={FaceAuthenticationColumnDefs}
                RowData={rowData}
                OnGridReady={onGridReady}
                IsPaginationEnabled={!IsMobileDevice}
                OnGridRowClick={(e) => { }}
                EmptyLabel={emptyLabels.FACE_AUTHENTICATION_FILES}
                IsFilterPresent={false}
                LockVisible={false}
                OnSelectionChanged={onSelectionChanged}
            />
            {openEditContactName &&
                <Dialog
                    maxWidth="sm"
                    fullWidth
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    open={openEditContactName}
                    onClose={() => { { setSelectedContact(undefined); setEditConatctName(false) } }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ paper: "br-2 w-p-30 dialogue-shadow " }}
                    disableEscapeKeyDown
                >
                    <DialogTitle className='p-2'>
                        <div className='d-flex justify-between align-center color-secure-file-dialog-title'>
                            <span className='h3-semibold'>
                                {DialogHeaders.EDIT_CONTACT_NAME}
                            </span>
                            <CancelIcon onClick={() => { setSelectedContact(undefined); setEditConatctName(false) }} className="c-pointer" />
                        </div>
                    </DialogTitle>
                    <DialogContent className='p-2'>
                        <TextField
                            variant="outlined"
                            name="name"
                            size='small'
                            value={selectedcontact?.Name}
                            onChange={(e) => { setSelectedContact(pre => ({ ...pre, Name: e.target?.value })) }}
                            InputProps={{
                                classes: { input: `${'h4-regular'} color-text-field-font` },
                            }}
                            className=" w-fill" />
                        <FormHelperText className={`h5-regular color-primary-danger t-align-right mr-1 h-2`}>
                            {selectedcontact?.Name?.length > 60 && "Contact Name should not exceed 60 characters"}
                        </FormHelperText>
                    </DialogContent>
                    <DialogActions className='pb-2 py-0'>
                        <ButtonComponent OnClick={() => { setSelectedContact(undefined); setEditConatctName(false) }} ButtonLabel={buttonLabels.CANCEL} ClassName={"ml-auto"} Variant={"secondary-btn-small"} />
                        <ButtonComponent OnClick={() => { editConatctName() }} Type={"submit"} ButtonLabel={buttonLabels.SAVE} ClassName={"px-4 mr-1"} Variant={selectedcontact?.Name?.length > 60 ? "disabled-btn-small" : "primary-btn-small"} Loading={isLoading} />
                    </DialogActions>
                </Dialog>
            }
            {
                <Confirm_Dialog
                    ButtonName={buttonLabels.DELETE}
                    onClose={closeConfirmDialog}
                    Show={show}
                    Text={appNote.DELETE_INVITE}
                    Loading={isLoading}
                    IsMobileDevice={IsMobileDevice}
                />
            }
        </div>
    )
}
export default SecureFileFaceAuthentication